"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Undo = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "2 2 20 20"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M13 5a8.96 8.96 0 0 0-6.145 2.442L4.707 5.293A1.002 1.002 0 0 0 3 6v11a1 1 0 0 0 1 1h11a1.002 1.002 0 0 0 .707-1.707l-3.51-3.509A3.993 3.993 0 0 1 16 10a4.005 4.005 0 0 1 4 3.998V14a1 1 0 0 0 2 0v-.005C21.998 9.035 17.961 5 13 5",
  fill: "none",
  fillRule: "evenodd"
}));

var _default = Undo;
exports.default = _default;